function pushGtmEvent(eventData) {
  if (typeof window.pushGTMEvent === 'function') {
    window.pushGTMEvent(eventData);
  }
}

export function getPublicationToggleLabel(scope) {
  return scope === 'site' ? 'Current Publication' : 'All Editorial Brands';
}

export function pushPublicationToggleChangedEvent(scope) {
  pushGtmEvent({
    event: 'search_publication_toggle_changed',
    publication_toggle: getPublicationToggleLabel(scope),
  });
}

// Handle sort toggle change (relevance / pub date) GA4 events
export function pushSearchSortChangedEvent(sortOrderSelected) {
  pushGtmEvent({
    event: 'search_sort_changed',
    sort_order: sortOrderSelected,
  });
}

function getSearchToggleEventFields() {
  const scope = $('.semantic-search-form [data-search-scope].is-active').attr('data-search-scope');
  const sortOrder = $('.js-semantic-remaining-results [data-sort-mode].is-active').attr('data-sort-mode');

  if (scope === undefined || sortOrder === undefined) {
    return {};
  }

  return {
    publication_toggle: getPublicationToggleLabel(scope),
    sort_order: sortOrder,
  };
}

// This function is triggered on semantic search page load
// to make sure initial toggle values are in the dataLayer
// Doesn't actually trigger an event
export function setToggleValuesInDataLayer() {
  pushGtmEvent(getSearchToggleEventFields());
}

export function pushSearchExecutedEvent({
  eventName,
  searchTerm,
  searchOrigin,
}) {
  const allowedSearchExecutedEvents = ['search_executed', 'search_executed_related_question'];
  if (!allowedSearchExecutedEvents.includes(eventName)) return;

  pushGtmEvent({
    event: eventName,
    search_term: searchTerm,
    search_origin: searchOrigin,
  });
}

// Build GA4 event data for search result clicks
function buildSearchResultSelectedEvent($link) {
  const $topResultCard = $link.closest('.semantic-search-card');
  const isTopResult = $topResultCard.length > 0;

  return {
    event: 'search_result_selected',
    search_term: $('#id_q').val() || '',
    result_title: isTopResult
      ? $link.find('.semantic-search-card__title').text().trim()
      : $link.text().trim(),
    result_url: $link.attr('href') || '',
    result_content_type: $link.attr('data-content-type') || '',
    result_top_match: isTopResult,
    ...(isTopResult ? {
      result_top_match_position: parseInt($topResultCard.attr('data-card-index'), 10) + 1,
    } : { result_top_match_position: undefined }),
  };
}

// Handle events triggered by users clicking on search results
export function handleSearchResultLinkClick(e) {
  const $link = $(e.currentTarget);
  pushGtmEvent(buildSearchResultSelectedEvent($link));
}
